import * as React from "react"
import { useComputed } from "@preact/signals-react"
import { Box } from "@mui/material"
import { ImageSeeker } from "@ui-seeker/core"

import { adminSkuFormData } from "../../@signals"


export default function AdminSkuFormSkuImage() {
    const imageURL = useComputed(() => adminSkuFormData.value.imageURL)

    return <Box display="flex" justifyContent="center" width={1}>
        <ImageSeeker
            src={imageURL.value || ""}
            sx={{
                height: 240,
                width: 240,
                objectFit: "contain",
                objectPosition: "center",
            }}
        />
    </Box>
}